if (!customElements.get('ci-contact')) customElements.define('ci-contact', class extends HTMLElement {
  connectedCallback() {
    if (this.abort) return;
    this.abort = new AbortController();
    const signal = this.abort.signal;
    this.form = this.querySelector('#ContactForm');
    this.state = this.querySelector('[data-contact-state]')?.dataset.contactState;
    this.scope = `ci-contact:${window.Shopify?.theme?.id || 'theme'}:${location.pathname}`;
    const copy = this.querySelector('[data-required]');
    this.querySelectorAll('input[required],textarea[required]').forEach(input => {
      input.addEventListener('invalid', () => {
        input.setCustomValidity('');
        if (input.validity.valueMissing) input.setCustomValidity(copy.dataset.required);
        else if (input.type === 'email' && input.validity.typeMismatch) input.setCustomValidity(copy.dataset.email);
      }, {signal});
      input.addEventListener('input', () => input.setCustomValidity(''), {signal});
    });
    // Preserve a new draft, including one started on the success page.
    for (const event of ['input', 'change']) this.form.addEventListener(event, event => {
      if (!event.target.matches('#ContactName, #ContactEmail, #ContactPhone, #ContactMessage, #ContactSubject')) return;
      if (this.draft) return;
      this.draft = true;
      this.saveEntry({draft: true});
    }, {signal});
    this.form.addEventListener('submit', () => {
      const attempt = crypto.randomUUID();
      this.draft = false;
      this.saveEntry({attempt, draft: false});
      this.store('pending', attempt);
      // Submission itself is NOT proof of success. Never reset here.
    }, {signal});
    this.reconcile();
    window.addEventListener('pageshow', event => {
      // persisted=true restores the old DOM; ordinary history loads can also
      // restore controls. Recheck after restoration, without polling/timers.
      this.reconcile();
      this.frame = requestAnimationFrame(() => this.reconcile());
    }, {signal});
  }
  entry() {
    const value = history.state?.ciContact;
    return value?.scope === this.scope ? value : {};
  }
  saveEntry(patch) {
    try { history.replaceState({...history.state, ciContact: {...this.entry(), ...patch, scope: this.scope}}, ''); } catch (_) { /* History may be restricted. */ }
  }
  store(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(`${this.scope}:${key}`);
      else sessionStorage.setItem(`${this.scope}:${key}`, value);
    } catch (_) { /* No storage: only the current confirmed success is reset. */ }
  }
  stored(key) {
    try { return sessionStorage.getItem(`${this.scope}:${key}`); } catch (_) { return null; }
  }
  reconcile() {
    if (this.state === 'error') {
      this.store('pending', null);
      return;
    }
    if (this.state === 'success' && !this.acknowledged) {
      this.acknowledged = true;
      const attempt = this.stored('pending');
      if (attempt) {
        this.store(`sent:${attempt}`, '1');
        this.saveEntry({attempt});
        this.store('pending', null);
      }
    }
    const entry = this.entry();
    const completed = entry.attempt && this.stored(`sent:${entry.attempt}`) === '1';
    if (!this.draft && !entry.draft && (this.state === 'success' || completed)) this.clearSubmittedFields();
  }
  clearSubmittedFields() {
    // reset() alone would restore server-rendered/customer defaults.
    for (const id of ['ContactName', 'ContactEmail', 'ContactPhone', 'ContactMessage']) {
      const input = this.form.querySelector(`#${id}`);
      input.defaultValue = '';
      input.value = '';
      input.setCustomValidity('');
    }
    const select = this.form.querySelector('#ContactSubject');
    [...select.options].forEach((option, index) => { option.defaultSelected = index === 0; });
    select.selectedIndex = 0;
  }
  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.abort?.abort();
    this.abort = null;
  }
});
